import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@xo-union/tk-component-buttons';
import buttonStyles from './form-buttons.scss';

const FormButtons = props => (
  <div className={buttonStyles.buttonContainer}>
    <div className={buttonStyles.flexContainer}>
      <Button
        className={buttonStyles.button}
        size="md"
        color="secondary"
        onClick={props.cancelCallback}
        disabled={props.disabled}
      >
        {props.cancelLabel}
      </Button>
      <Button
        className={buttonStyles.button}
        size="md"
        color="primary"
        onClick={props.confirmCallback}
        disabled={props.disabled || props.confirmDisabled}
      >
        {props.confirmLabel}
      </Button>
      {props.children}
    </div>
    <br />
    {props.deleteCallback && (
      <Button size="md" color="tertiary" onClick={props.deleteCallback} disabled={props.disabled}>
        {props.deleteLabel}
      </Button>
    )}
  </div>
);

FormButtons.propTypes = {
  confirmCallback: PropTypes.func.isRequired,
  cancelCallback: PropTypes.func.isRequired,
  deleteCallback: PropTypes.func,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  deleteLabel: PropTypes.string,
  disabled: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
  children: PropTypes.node,
};

FormButtons.defaultProps = {
  confirmLabel: 'OK',
  cancelLabel: 'Cancel',
  deleteLabel: 'Delete',
  disabled: false,
};

export default FormButtons;
